import {ReactNode} from "react";

export default function Container({ children }: { children: ReactNode }) {
  return (
    <div className="mx-3 my-2">{children}</div>
  )
}